// extracted by mini-css-extract-plugin
module.exports = {"content":"Buttons_content__jYvG8","buttons":"Buttons_buttons__1SOmz","defaultButton":"Buttons_defaultButton__2WCsn"};